import { create } from 'zustand';
import type { MeetingType } from './types';

type RecordingStatus = 'idle' | 'recording' | 'uploading' | 'processing' | 'done' | 'failed';

const LAST_PROJECT_KEY = 'secretary:lastProjectId';
const LAST_TYPE_KEY = 'secretary:lastMeetingType';

interface SecretaryState {
  isSheetOpen: boolean;
  projectId: string | null;
  meetingType: MeetingType;
  languageHints: string[];
  participants: string[];
  recordingStatus: RecordingStatus;
  sessionId: string | null;
  durationSec: number;
  processingStatus: string | null;

  openSheet: () => void;
  closeSheet: () => void;
  reset: () => void;
  setProjectId: (id: string | null) => void;
  setMeetingType: (t: MeetingType) => void;
  setLanguageHints: (l: string[]) => void;
  setParticipants: (p: string[]) => void;
  setRecordingStatus: (s: RecordingStatus) => void;
  setSessionId: (id: string | null) => void;
  setDurationSec: (n: number) => void;
  setProcessingStatus: (s: string | null) => void;
}

export const useSecretaryStore = create<SecretaryState>((set) => ({
  isSheetOpen: false,
  projectId: localStorage.getItem(LAST_PROJECT_KEY),
  meetingType: (localStorage.getItem(LAST_TYPE_KEY) as MeetingType) || 'internal',
  languageHints: ['ru', 'en'],
  participants: [],
  recordingStatus: 'idle',
  sessionId: null,
  durationSec: 0,
  processingStatus: null,

  openSheet: () => set({ isSheetOpen: true }),
  closeSheet: () => set({ isSheetOpen: false }),
  reset: () =>
    set({
      recordingStatus: 'idle',
      sessionId: null,
      durationSec: 0,
      processingStatus: null,
      participants: [],
    }),
  setProjectId: (id) => {
    if (id) localStorage.setItem(LAST_PROJECT_KEY, id);
    set({ projectId: id });
  },
  setMeetingType: (t) => {
    localStorage.setItem(LAST_TYPE_KEY, t);
    set({ meetingType: t });
  },
  setLanguageHints: (l) => set({ languageHints: l }),
  setParticipants: (p) => set({ participants: p }),
  setRecordingStatus: (s) => set({ recordingStatus: s }),
  setSessionId: (id) => set({ sessionId: id }),
  setDurationSec: (n) => set({ durationSec: n }),
  setProcessingStatus: (s) => set({ processingStatus: s }),
}));
